// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__39yk5","title":"styles_title__1_SYW"};